import { LitElement, css, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import '../components/search-query';
import '../components/user-menu';
import { NavigateHomeEvent } from '../events';
import { switchLayout } from '../media-query';
import { resolveRouterPath } from '../router';
import { Layout, PAGE } from '../state/pages';
import { AppUser } from '../state/users';
import { styles as sharedStyles } from '../styles/shared-styles';

@customElement('app-header')
export class AppHeader extends LitElement {

  @property({ type: String, state: false, attribute: "title" })
  title: string = 'Supermarktprijzen';

  @property({ attribute: false, type: Object })
  user: AppUser | null = null;

  @property({ attribute: false, type: Number })
  layout: number = Layout.PHONE;

  @property({ attribute: false, type: Number })
  watchlistCount: number = 0;

  @property({ attribute: false, type: String })
  watchlistName: string = "";

  @property({ attribute: false, type: Number })
  page: PAGE = PAGE.WELCOME;

  static styles = [
    sharedStyles,
    css`
    :host {
      display: flex;
      justify-content: space-evenly;      
      align-items: center;
      background: var(--sl-color-primary-600);
      color: white;
      margin: 0px;
      padding: 0px 15px;
      box-sizing: border-box; 
      width: 100%;
      height: 100%;
   }

    h1 {
      margin: 0;
      color: var(--sl-color-primary-800);
    }

    header {
      flex: 1;
    }

    nav {
      display: flex;
      align-items: center;
    }

    nav .hamburger {
       flex: 0 0 auto;
       display: flex;
       align-items: center;
    }

    nav .search {
        flex: 1; /* Expands to take maximum available space */
        align-items: center;
        max-width: 800px;
        margin: auto;
    }
    
    nav .watchlist {
      display: flex;
      align-items: center;
    }    

    nav .usermenu {
        display: flex;
        align-items: center;
    }
    
  `];

  fontSize() {
    return switchLayout(this.layout, "1.5rem", "1.5rem", "2.0rem", "2.0rem");
  }

  renderWatchlist() {
    return html`
          <sl-button class=${switchLayout(this.layout, "watchlist phone", "watchlist tablet", "watchlist laptop", "watchlist desktop")} 
            variant="text" 
            size=${switchLayout(this.layout, "small", "small", "medium", "large")}
            href=${resolveRouterPath("/account/list")}>
            ${this.layout<=Layout.TABLET ? html`<sl-icon slot="prefix" name="eye"></sl-icon>` : nothing}            
            ${this.layout > Layout.TABLET ? this.watchlistName : nothing}         
            <span slot="suffix">
              <sl-badge variant="primary" pill>${this.watchlistCount}</sl-badge>
            </span>
          </sl-button>
    `;
  }

  renderSearch() {
    if (this.page===PAGE.WELCOME) {
      // there is already a search on the welcome page
      return nothing;
    } else {
      return html`
        <search-query .layout=${this.layout} query=""></search-query>
      `;
    }
  }

  render() {
    return html`
      <header>
        <nav>
          <div class="hamburger" @click=${this.onNavigateHome}>
            <sl-icon-button class="home" name="house-fill" label="home" style="font-size: ${this.fontSize()}"><sl-icon-button>
          </div>
          <div class="search">
            ${this.renderSearch()}
          </div>
          ${this.renderWatchlist()}
          <user-menu class="usermenu"
            .user=${this.user}
            layout="${this.layout}">
          </user-menu>
        </nav>
      </header>
    `;
  }

  onNavigateHome(_event: TouchEvent) {
    this.dispatchEvent(new NavigateHomeEvent())
  }

}
